import React from 'react';
import { Group } from '../../types/group';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import BlockIcon from '@mui/icons-material/Block';
import DoneIcon from '@mui/icons-material/Done';
import useConfigStyles from '../../components/useConfigStyles';

type JobGroupsProps = {
  groups: Group[];
  editable: boolean;
  removeGroup: (group: Group) => void;
};

function JobGroups({ groups, editable, removeGroup }: JobGroupsProps): JSX.Element {
  const classes = useConfigStyles();

  const handleOnDelete = (group: Group) => {
    removeGroup(group);
  };

  return (
    <TableContainer component={Paper} className={classes.tableContainer}>
      <Table className='table' aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell>Group</TableCell>
            <TableCell align='center'>Severity</TableCell>
            <TableCell align='center'>Enabled</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {groups.map((group) => (
            <TableRow key={group.Name}>
              <TableCell component='th' scope='row'>
                {group.Name}
              </TableCell>
              <TableCell align='center'>{group.Severity}</TableCell>
              <TableCell align='center'>{!group.Disabled ? <DoneIcon /> : <BlockIcon />}</TableCell>
              <TableCell align='center'>
                {editable && (
                  <IconButton color='secondary' onClick={() => handleOnDelete(group)}>
                    <DeleteIcon />
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default JobGroups;
